import type { TFunction } from "i18next";

import type {
  CountProgress,
  KnowledgeCheckState,
  ModuleOverview,
} from "@/domains/certifications/types";
import type { RequirementChipProps } from "@/domains/certifications/components/types";

const knowledgeCheckLabel = (
  t: TFunction,
  check: NonNullable<ModuleOverview["knowledgeCheck"]>,
) => {
  const labels: Record<KnowledgeCheckState, string> = {
    notStarted: "checkNotStarted",
    underReview: "checkUnderReview",
    anotherRound: "checkReturned",
    passed: "checkPassed",
    failed: "checkFailed",
  };
  return t(`certification.overview.chips.${labels[check.checkState]}`);
};

const countChip = (
  t: TFunction,
  key: string,
  count: CountProgress,
): RequirementChipProps => ({
  label: t(key, { current: count.current, target: count.target }),
  isMet: count.current >= count.target,
});

export const buildRequirementChips = (
  t: TFunction,
  week: ModuleOverview,
): RequirementChipProps[] => {
  const chips: RequirementChipProps[] = [];
  if (week.videos) {
    chips.push(
      countChip(t, "certification.overview.chips.videos", week.videos),
    );
  }
  if (week.readings) {
    chips.push(
      countChip(t, "certification.overview.chips.readings", week.readings),
    );
  }
  if (week.knowledgeCheck) {
    chips.push({
      label: knowledgeCheckLabel(t, week.knowledgeCheck),
      isMet: week.knowledgeCheck.isPassed,
    });
  }
  if (week.posts) {
    chips.push(countChip(t, "certification.overview.chips.posts", week.posts));
  }
  if (week.comments) {
    chips.push(
      countChip(t, "certification.overview.chips.comments", week.comments),
    );
  }
  return chips;
};
